module.exports = __webpack_public_path__ + "img/smartsheet.0a44d34d.png";